// extracted by mini-css-extract-plugin
module.exports = {"preloaderStyle":"Preloader_preloaderStyle__3LJDp"};